module.exports = __webpack_public_path__ + "img/card-btn-1.65b54779.png";